import voucher from '../bixmodel/voucher';

window.ttx = window.ttx || {};
ttx.models = ttx.models || {};

//= =====================================================
ttx.models.register = function (modelType, func) {
    ttx.models[modelType] = func(modelType);
};

ttx.models.DataStates = {
    Insert: 'Insert',
    Update: 'Update',
    Delete: 'Delete',
    Unchanged: 'Unchanged'
};


// 异步加载（打包工具会处理路径，等价于原require）
async function initModels() {
    try {
        // 动态import替代require，支持省略.js后缀
        // 基础模型层（BaseModel/SimpleModel/ContainerModel/GridModel/TreeModel/ListModel）先行加载
        await Promise.all([
            import('./models/baseModel'),
            import('./models/simpleModel'),
            import('./models/searchModel'),
            import('./models/containerModel'),
            import('./models/gridModel'),
            import('./models/treeModel'),
            import('./models/listModel')
        ]);
        // MDF 兼容模型层：FilterModel / TagModel / FilterViewModel / ReferViewModel
        // 注：这些模型在构造函数内通过 ttx.models.XxxModel 运行时查找依赖，故可与基础层并行加载
        await Promise.all([
            import('./models/filterModel'),
            import('./models/tagModel'),
            import('./models/filterViewModel'),
            import('./models/referViewModel')
        ]);
        // 空桩：防止 simpleModel 的 instanceof 检查报错
        ttx.models.CharacterModel = function CharacterModel(data) { ttx.models.BaseModel.call(this, data); };
        ttx.models.CharacterModel.prototype = ttx.utils.getPrototype(ttx.models.BaseModel.prototype);
        await import('./models/formulaMixin');
    } catch (err) {
        ttx.console.error(null, '加载失败：', err);
    }
}

/** 获取单据级 ViewModel 实现（按 billtype 分发，对应 cb index.ts 调度表） */
ttx.models.getBizModel = function (billType) {
    billType = (billType || '').toLowerCase();
    switch (billType) {
        case 'card':
        case 'list':
            return voucher;
        default:
            return null;
    }
};

/** 获取区块级 ViewModel 实现（MDF 兼容：filterviewmodel / referviewmodel / treemodel / listmodel） */
ttx.models.getViewModel = function (type) {
    switch (type) {
        case 'filterviewmodel':
            return ttx.models.FilterViewModel;
        case 'referviewmodel':
            return ttx.models.ReferViewModel;
        case 'treemodel':
            return ttx.models.TreeModel;
        case 'listmodel':
            return ttx.models.ListModel;
        default:
            return null;
    }
};

initModels();
